import { useSelector } from 'react-redux'
import { isAllowed } from 'src/selectors/modules.selector'
import { inventoriesPermissions, warehousePermissions } from 'src/enums/permissions'

interface UseWarehouseInventoryPermissionResponse {
  seeSum: boolean
  seeMoneyValues: boolean
  seeCost: boolean
}

export const useWarehouseInventoryPermission = (
  isInventory: boolean,
): UseWarehouseInventoryPermissionResponse => {
  const seeMoneyBalances = useSelector(state =>
    isAllowed(state, [
      isInventory
        ? inventoriesPermissions.seeMoneyBalances
        : warehousePermissions.seeMoneyValues,
    ]),
  )

  const seeSum = useSelector(state => isAllowed(state, [warehousePermissions.seeSum]))
  const seeCost = useSelector(state =>
    isAllowed(state, [inventoriesPermissions.seeCostAndTotal]),
  )

  return {
    seeSum: !isInventory && seeSum && seeMoneyBalances,
    seeMoneyValues: seeMoneyBalances,
    seeCost: isInventory && seeCost && seeMoneyBalances,
  }
}
